<template>
    <div class="lockdesigner-panel-header">
        <div v-if="backVisible" class="lockdesigner-panel-header__back-button" @click="goBack">
            <font-awesome-icon :icon="['fass', 'arrow-left']" />
        </div>

        <h6>
            <a href="/" class="lockdesigner-logo-link" target="_blank">
                <img src="/ResourcePackages/BaldwinHardware/assets/dist/images/logos/baldwinlogowhite.svg?version=1" alt="Baldwin Logo" height="26" width="140" />
            </a>
            <span>|</span>
	        <a href="/lock-designer" class="lockdesigner-logo-text">
		        <span class="lock-text">LOCK DESIGNER</span>
	        </a>
        </h6>
        <div class="lockdesigner-panel-header__home-button">
            <a href="/lock-designer">
                <font-awesome-icon :icon="['fasr', 'house']" />
            </a>
        </div>
    </div>
</template>

<script setup>
import { computed, defineEmits, defineComponent } from 'vue';
import Cta from 'Vue/components/lockDesigner/components/shared/Cta.vue';
const emit = defineEmits(['update-route-back']);
import { useStore } from 'vuex';
const store = useStore();
import { useRouter } from 'vue-router';
const router = useRouter();

defineComponent({
    name: 'LockDesignerHeader',
});
const props = defineProps({
    backToRoute: {
        type: String,
        default: null,
    },
});

// const restart = async () => {
//     window.location.href = '/lock-designer';
// };

const backVisible = computed(() => !!props.backToRoute);

function goBack() {
    emit('update-route-back', props.backToRoute);
}
</script>
